import * as React from "react";
import "./styles.scss";

interface FormErrorMessageProps {
    message: string;
}

const FormErrorMessage = (props: FormErrorMessageProps): JSX.Element => {
    return <div className="formErrorMessage__text">{props.message}</div>;
};

export default FormErrorMessage;
